import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data/data.service';
import { CustomersService } from '../../../../customers/customers.service';
import { AuthService } from '../../../../auth/auth.service';

@Component({
  selector: 'exa-utility-bills-dashboard-pg',
  templateUrl: './utility-bills-dashboard-pg.html',
  styleUrls: ['./utility-bills-dashboard-pg.scss']
})
export class UtilityBillsDashboardPgComponent implements OnInit {

  reportId = "";
  accessToken = "";
  embedUrl = "";
  workspaceId = "75af7b4f-7b5f-4fbf-8577-ced5004ce4ea";
  showReportIframe = false;
  accountId = "";

  constructor(
    private data: DataService,
    private customersService: CustomersService,
    private authService: AuthService
  ) {
    var user = authService.getUser();
    var customer = this.customersService.getCurrentCustomer();
    if(user && user.account && user.account.id){
      this.accountId = user.account.id;
    } else if(customer && customer.id){
      this.accountId = customer.id;
    }
  }

  otherReports = [
    { name: "Daily Trend", id: "49cd8bff-8987-4d99-be5a-84b8529e84c0", pageName: "1c4471cc2bbf5f82bb0f" }
  ];

  dataInputReports = [
    { name: "Fiscal Year", id: "781f2fbb-849f-4fbb-bc47-791570d36871", pageName: "97df0be0dce9a26dc7d0" },
    { name: "Utility Contract Report", id: "781f2fbb-849f-4fbb-bc47-791570d36871", pageName: "3fa39c7156e87a2da467" },
    { name: "Data Schema", id: "781f2fbb-849f-4fbb-bc47-791570d36871", pageName: "4d07acc88c1c9a08dc57" },
    { name: "Replaced / Duplicate Bills", id: "86724b9b-a447-4ab3-a3c2-ff75ca3c88f0" },
    { name: "Account Status Alert", id: "3c809c6a-b727-4f6c-b0cb-fb27e21da1bb" },
  ];

  monthlyReports = [
    { name: "Monthly Accrual Report", id: "0a529a60-44d5-4ca6-a9c0-1eb31c6160ae" },
    { name: "Monthly Utility Forecast", id: "97f5fd82-3545-411a-a4d0-2e37e52b7966" },
    { name: "Monthly Variance Report", id: "05701bb6-a10c-47a4-86ab-922fb7138c3c" }
  ];

  analysisReports = [
    { name: "Rate Analysis", id: "095307f6-e904-4b64-adc2-45935f23d28e" },
    { name: "Energy Forecast Report", id: "8fd72fc4-80d3-49a0-9324-47956f42642b" },
    { name: "Weather Report", id: "dde3b6d1-3824-421d-8e12-df2722feeae9" },
    { name: "Consumption Analysis", id: "bb9f6512-8bc8-451c-a496-6723378399b3" },
    { name: "YoY Consumption Trend", id: "fd1663b6-cf29-4c89-ad46-96d2d644e835" },
    { name: "Annual Waste Trend", id: "cc721252-9889-4c07-8848-12b69532bd9f" },
    { name: "Anomalies Report", id: "bb8e4b06-1d11-4786-9b7a-1706ee648aba" },
    { name: "Bills Pay Status", id: "e4906270-5696-4102-aa9f-8d07b712d515" },
    { name: "Energy Intensity Unit Trend", id: "54d0fcd0-a68c-4d3a-9cfc-f809d4df1ab6" },
  ];

  energyStarBenchmarkingReports = [
    { name: "Energy Star Score", id: "0604245e-8ec6-4b79-b508-2c305b8df105" }
  ];

  generateReport(report) {
    this.accessToken = null;
    report.isLoading = true;
    this.showReportIframe = true;
    this.data.generatePowerBIReportToken({ report_id: report.id, workspace_id: this.workspaceId }).subscribe(
      (response) => {
        this.accessToken = response.toString();
        this.reportId = report.id;
        this.embedUrl =`https://app.powerbi.com/reportEmbed?embed=true&reportId=${report.id}&groupId=${this.workspaceId}` + (report.pageName ? `&pageName=${report.pageName}` : '') + (`&filter=CassSite/Account_id eq '${this.accountId}'`);
        report.isLoading = false;
      },
      (error) => {
        console.error('Error:', error);
        report.isLoading = false;
      }
    );
  }

  showAllReports(){
    this.showReportIframe = false;
  }

  ngOnInit() {
  
  }
}
